// extracted by mini-css-extract-plugin
export default {"card":"QuoteOfTheDay_card__vOjbo","title":"QuoteOfTheDay_title__Ft-8d","tip":"QuoteOfTheDay_tip__2A+2j"};